export const INVOICE_SAGE_STATUS = {
  '1': '<span class="w-100 fw-bold m-1 py-2 px-3 text-warning bg-warning-subtle rounded">PENDING</span>',
  '2': '<span class="w-100 fw-bold m-1 py-2 px-3 text-danger bg-danger-subtle rounded">ERROR</span>',
  '3': '<span class="w-100 fw-bold m-1 py-2 px-3 text-success">COMPLETED</span>',
  '4': '<span class="w-100 fw-bold m-1 py-2 px-3 text-info">COMPLETED (NEW USER)</span>',
  '5': '<span class="w-100 fw-bold m-1 py-2 px-3 text-info">UPDATED</span>',
};
